<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">Reporte de transporte escolar</h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>

      <v-speed-dial
        key="1"
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-btn color="gradiente" dark fab>
            <v-icon>more_vert</v-icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadPdf"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>Descargar PDF</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsx"
          >
            <v-img
              :style="{ flex: '0 1 auto' }"
              height="28px"
              width="28px"
              :src="require('@/assets/reports/IconoCSV.png')"
            />
          </v-btn>
          <span>Descargar XLSX</span>
        </v-tooltip>
      </v-speed-dial>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 120px !important;
      "
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-left="500"
                    :nudge-width="500"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Buscar"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        v-model="filters.search"
                        @keyup.enter="getItems"
                        @click:clear="
                          {
                            filters.search = ''
                            getItems()
                          }
                        "
                      >
                        <template v-slot:append>
                          <v-icon v-on="on">tune</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <!-- Level -->
                          <v-flex xs12 sm6 md4 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="filterLevels"
                                  v-model="filters.levelIds"
                                  item-text="levelName"
                                  item-value="levelId"
                                  label="Nivel"
                                  flat
                                  solo
                                  hide-details
                                  return-object
                                  no-data-text="No hay registros para filtrar"
                                  @change="filterLevel"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- Group -->
                          <v-flex xs12 sm6 md4 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="filterGG"
                                  v-model="filters.gradeGroupIds"
                                  item-text="groupName"
                                  label="Grupo"
                                  item-value="groupId"
                                  flat
                                  solo
                                  hide-details
                                  no-data-text="No hay registros para filtrar"
                                  @change="getItems"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- Routes -->
                          <v-flex xs12 sm6 md4 pa-1>
                            <v-layout>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>
                                    schedule
                                  </v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="posibleFilters.routes"
                                  v-model="filters.routesIds"
                                  item-text="name"
                                  item-value="id"
                                  label="Ruta"
                                  solo
                                  flat
                                  hide-details
                                  @change="getItems"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- initial date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>Fecha de inicio</v-flex>
                                <v-flex xs7 sm8 pl-0 ml>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="dateParse(timeFirst)"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="firstDate"
                                      :max="today"
                                      v-model="timeFirst"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <!-- final date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>Fecha de fin</v-flex>
                                <v-flex xs7 sm8 pl-0>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        id="last-small"
                                        :value="dateParse(timeLast)"
                                        label="Fecha de fin"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                        solo
                                        flat
                                        hide-details
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="timeFirst"
                                      :max="today"
                                      v-model="timeLast"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions
                        style="justify-content: end; margin-right: 8px"
                      >
                        <v-flex
                          xd12
                          sm7
                          md4
                          style="display: flex; justify-content: end"
                        >
                          <v-btn
                            @click="filterClear"
                            v-show="showFilter"
                            color="primary"
                          >
                            <v-icon left>close</v-icon>
                            Limpiar filtros
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoadingTable"
                :pagination.sync="pagination"
                @update:pagination="getItems"
                no-data-text="No hay rutas creadas"
                no-results-text="No hay resultados"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :style="header.style ? header.style : 'width: 150px'"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:items="props">
                  <tr>
                    <td style="width: 70px">
                      <v-avatar size="30px">
                        <img
                          v-if="
                            props.item.imageStorage &&
                            props.item.imageStorage.miniObjUrl
                          "
                          :src="props.item.imageStorage.miniObjUrl"
                          :alt="
                            props.item.firstName + ' ' + props.item.lastName
                          "
                        />
                        <v-icon v-else>account_circle</v-icon>
                      </v-avatar>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{
                          `${props.item.firstName ? props.item.firstName : '-'}`
                        }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{
                          `${props.item.lastName ? props.item.lastName : '-'}`
                        }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{ `${props.item.level ? props.item.level : '-'}` }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{
                          `${
                            props.item.gradeGroup ? props.item.gradeGroup : '-'
                          }`
                        }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      {{ `${props.item.personId ? props.item.personId : '-'}` }}
                    </td>
                    <td>
                      {{ parseDate(props.item.queueDate) }}
                      <br />
                      {{ parseTime(props.item.queueDate) }}
                    </td>
                    <td>
                      {{ parseDate_Time(props.item.deliverDate) }}
                    </td>
                    <td>
                      {{ props.item.route.name }}
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{
                          props.item.driver && props.item.driver.firstName
                            ? props.item.driver.firstName
                            : '-'
                        }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{
                          props.item.driver && props.item.driver.lastName
                            ? props.item.driver.lastName
                            : '-'
                        }}
                      </CustomTooltipOverflowText>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <ReportSettings
      :show="showSetting"
      title="Configuración de reporte de asistencia"
      reportSettingtype="STUDENT_ASSISTANCE"
      @closeEditSetting="onCloseEditSetting"
    />
    <Error v-model="modals.showError" :text="modals.errorText"> </Error>
    <Success v-model="modals.showSuccess" :text="modals.successText"> </Success>
    <Loading v-model="modals.showLoading" text="Cargando..." />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import {
  _genericDownloadFile,
  _getUserPermissions,
  _isSomeDifferent,
  _keyVal,
} from '../../../../utils/genericUtils.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import Success from '../../../Dialogs/Success.vue'
import ReportSettings from '../../../Modals/reportSettings/reportSettings.vue'
import SortTableArrow from '../../../Tools/SortTableArrow.vue'
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'
import {
  filterByLevel,
  isNotEmpty,
  parseGroups,
  parseLevels,
} from '../utils.js'

export default {
  components: {
    Error,
    Success,
    SortTableArrow,
    ReportSettings,
    Loading,
    CustomTooltipOverflowText,
  },
  data() {
    return {
      userPermissions: {},
      possibleUserModulePermissions: {
        WATCH_TRANSPORT_ROUTE: 'WATCH_TRANSPORT_ROUTE',
      },
      showSetting: false,
      noRecord: 'Sin registro',
      modals: {
        showError: false,
        errorText: '',
        showSuccess: false,
        successText: '',
        showLoading: false,
      },
      timeFirst: moment().format('YYYY-MM-DD'),
      timeLast: moment().format('YYYY-MM-DD'),
      today: new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(Date.now()),
      filterLevels: [],
      filterGG: [],
      selectedLevelId: null,
      selectedLevelType: null,
      posibleFilters: { gradeGroups: [], levels: [], routes: [] },
      filters: {
        search: '',
        gradeGroupIds: '',
        levelIds: '',
        routesIds: '',
      },
      showFilter: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
      },
      headers: [
        {
          text: 'Foto',
          value: 'pic',
          sortable: true,
          align: 'center',
          style: 'width: 70px',
        },
        {
          text: 'Nombre',
          value: 'NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Apellido',
          value: 'LAST_NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Nivel',
          value: 'LEVEL',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Grupo',
          value: 'group',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Matrícula',
          value: 'ID',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha y hora de subida',
          value: 'ID',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha y hora de bajada',
          value: 'TIME_IN',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Nombre ruta',
          value: 'TIME_OUT',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Nombre chofer',
          value: 'TIME_OUT',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Apellido chofer',
          value: 'TIME_OUT',
          sortable: true,
          align: 'center',
        },
      ],
      isLoadingTable: false,
      items: [],
      totalItems: 0,
    }
  },
  created() {
    this.getItems(true)
  },
  async mounted() {
    // don't call api table here, it's already called on the watch
    this.getLevelToFilter()
    if (this.getUser != null && this.getUser.id) {
      this.mapPermits()
    }
  },
  methods: {
    dateParse(date) {
      if (date != null) {
        return moment(date).format('DD/MM/YYYY')
      }
      return ''
    },
    parseDate_Time(epochTime) {
      if (epochTime === undefined) return this.noRecord
      return `${this.parseDate(epochTime)}\n${this.parseTime(epochTime)}`
    },
    parseDate(epochTime) {
      if (epochTime === undefined) return this.noRecord
      return moment(new Date(epochTime)).format('L')
    },
    parseTime(epochTime) {
      if (epochTime === undefined) return this.noRecord
      return moment(new Date(epochTime)).format('HH:mm:ss')
    },
    onCloseEditSetting() {
      this.showSetting = false
    },
    showSettingModal() {
      this.showSetting = true
    },
    async downloadPdf() {
      const params = {
        search: this.filters.search,
        from: this.timeFirst,
        to: this.timeLast,
      }

      const isGradeGroupsSelected =
        this.filters.gradeGroupIds !== '' &&
        this.filters.gradeGroupIds !== null &&
        this.filters.gradeGroupIds !== undefined
      const isLevelSelected =
        this.filters.levelIds !== '' &&
        this.filters.levelIds !== null &&
        this.filters.levelIds !== undefined

      if (isGradeGroupsSelected) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isLevelSelected) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }

      const response = await this.$store.dispatch('transport/getPdf', params)

      _genericDownloadFile({
        documentName: 'reporte.pdf',
        blob: response.data,
      })
    },
    async downloadXlsx() {
      let params = {
        search: this.filters.search,
        from: this.timeFirst,
        to: this.timeLast,
      }

      const isGradeGroupsSelected =
        this.filters.gradeGroupIds !== '' &&
        this.filters.gradeGroupIds !== null &&
        this.filters.gradeGroupIds !== undefined
      const isLevelSelected =
        this.filters.levelIds !== '' &&
        this.filters.levelIds !== null &&
        this.filters.levelIds !== undefined

      if (isGradeGroupsSelected) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isLevelSelected) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }

      const response = await this.$store.dispatch('transport/getXlsx', params)

      _genericDownloadFile({
        documentName: 'reporte.xlsx',
        blob: response.data,
      })
    },
    _offsetHandler() {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage
    },
    async getItems(isInitialStateParams = false) {
      const params = {
        search:
          this.filters.search.trim() === '' ? undefined : this.filters.search,
        offset: this._offsetHandler(),
        size: this.pagination.rowsPerPage,
        from: this.timeFirst,
        to: this.timeLast,
      }

      if (isNotEmpty(this.filters.gradeGroupIds)) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isNotEmpty(this.filters.levelIds)) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }
      if (isNotEmpty(this.filters.routesIds)) {
        params.routeIds = this.filters.routesIds
      }

      if (isInitialStateParams === true) {
        this.initialStateParams = _keyVal(params)
        return
      }

      this.showFilter = _isSomeDifferent(
        this.initialStateParams,
        _keyVal(params)
      )

      this.isLoadingTable = true
      try {
        const { data } = await this.$store.dispatch(
          'transport/getRouteStudents',
          params
        )

        this.items = data.data

        this.totalItems = data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingTable = false
      }
    },
    _resetLevels() {
      this.filterGG = this.posibleFilters.gradeGroups
      this.filters.levelIds = ''
    },
    _resetGradeGroups() {
      this.filterLevels = this.posibleFilters.levels
      this.filters.gradeGroupIds = ''
    },
    async filterLevel() {
      if (this.filters.levelIds.length === 0) {
        this._resetLevels()
        return
      }

      const groups = filterByLevel({
        levelIds: this.filters.levelIds.map((e) => e.levelId),
        posibleGroups: this.posibleFilters.gradeGroups,
      })
      this.filterGG = groups
    },
    async getLevelToFilter() {
      try {
        const { data } = await this.$store.dispatch(
          'transport/getRouteStudentsReportFilters'
        )
        const levels = parseLevels({ levels: data.levels })
        const groups = parseGroups({ gradeGroups: data.levels })
        this.filterLevels = levels
        this.filterGG = groups

        this.posibleFilters = {
          gradeGroups: groups,
          levels: levels,
          routes: data.routes,
        }
      } catch (error) {
        console.log(error)
        this.posibleFilters = { gradeGroups: [], levels: [], routes: [] }
      }
    },
    filterClear() {
      this._resetLevels()
      this._resetGradeGroups()
      this.pagination.page = 1
      this.pagination.descending = false
      this.pagination.rowsPerPage = 25
      this.showFilter = false
      this.filters.search = ''
      this.filters.gradeGroupIds = ''
      this.filters.levelIds = ''
      this.filters.routesIds = ''
      this.timeFirst = moment().format('YYYY-MM-DD')
      this.timeLast = moment().format('YYYY-MM-DD')
      this.getItems()
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
  },
  watch: {
    async timeFirst() {
      if (this.timeFirst === null || this.timeLast === null) return
      await this.getItems()
    },
    async timeLast() {
      if (this.timeFirst === null || this.timeLast === null) return
      await this.getItems()
    },
    'filters.levelIds': function () {
      this.getItems()
    },
    getUser() {
      this.mapPermits()
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.icon-select {
  padding: 8px;
}

/* pill */
.pill_success-bg {
  background-color: #d1fae5;
}

.pill_success-dot {
  background-color: #34d399;
}

.pill_success-text {
  color: #065f46;
}

.pill_warning-bg {
  background-color: #fef3c7;
}

.pill_warning-dot {
  background-color: #fbbf24;
}

.pill_warning-text {
  color: #92400e;
}

.pill_danger-bg {
  background-color: #fbdfde;
}

.pill_danger-dot {
  background-color: #d92a2a;
}

.pill_danger-text {
  color: #b91b19;
}

.custom_pill {
  border-radius: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* height: 20px; */

  padding: 2px 10px;
  height: auto;
  width: 100%;
  margin-right: 10px;
}

.custom_pill-text {
  text-transform: capitalize;
}

.custom_pill-dot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-right: 5px;
}

.custom_row {
  padding: 0;
  display: flex;
  align-items: center;
  padding: 0 !important;
  padding-right: 15px !important;
}

.disabled {
  opacity: 0.3;
  cursor: default;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
